import React, { useState } from "react";
import { useSelector } from "react-redux";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { motion } from "framer-motion";
import "../../Styles/PendingService.css";

export const CompleteService = () => {
  // Static data for Complete services
  const [CompleteServices, setCompleteServices] = useState([
    {
      id: 1,
      name: "John Doe",
      phoneNo: "9876543210",
      schedule: "2023-06-15",
      state: "California",
      employeeName: "Alice Smith",
      status: "Complete",
    },
    {
      id: 2,
      name: "Jane Smith",
      phoneNo: "8765432109",
      schedule: "2023-06-16",
      state: "New York",
      employeeName: "Bob Johnson",
      status: "In Progress",
    },
    {
      id: 3,
      name: "Mike Johnson",
      phoneNo: "7654321098",
      schedule: "2023-06-17",
      state: "Texas",
      employeeName: "Charlie Brown",
      status: "Complete",
    },
    {
      id: 4,
      name: "Sarah Williams",
      phoneNo: "6543210987",
      schedule: "2023-06-18",
      state: "Florida",
      employeeName: "Diana Prince",
      status: "Complete",
    },
    {
      id: 5,
      name: "David Lee",
      phoneNo: "5432109876",
      schedule: "2023-06-19",
      state: "Washington",
      employeeName: "Ethan Hunt",
      status: "Complete",
    },
  ]);

  const [selectedService, setSelectedService] = useState(null);
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState(new Date());
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openSubmenu, setOpenSubmenu] = useState({ type: null, id: null });
  const [selectedOutput, setSelectedOutput] = useState("");
  const [showOutputModal, setShowOutputModal] = useState(false);

  const statusOptions = ["Complete", "In Progress", "Completed", "Cancelled"];
  const serviceOutputOptions = [
    "Confirm Pick Up",
    "Picked Up with OTP",
    "Nearest Store",
    "Company Ware House",
    "Run For",
    "Delivery with OTP",
    "Delivered",
  ];

  const toggleDropdown = (id) => {
    setOpenDropdownId(openDropdownId === id ? null : id);
    setOpenSubmenu({ type: null, id: null });
  };

  const toggleSubmenu = (type, id, e) => {
    e.stopPropagation();
    setOpenSubmenu(
      openSubmenu.type === type && openSubmenu.id === id
        ? { type: null, id: null }
        : { type, id }
    );
  };

  const handleStatusChange = (id, status) => {
    setCompleteServices(
      CompleteServices.map((service) =>
        service.id === id ? { ...service, status } : service
      )
    );
    setOpenSubmenu({ type: null, id: null });
  };

  const handleOpenDeliveryModal = (service) => {
    setSelectedService(service);
    setShowDeliveryModal(true);
    setOpenDropdownId(null);
  };

  const handleSaveDelivery = () => {
    setShowDeliveryModal(false);
  };

  // Close dropdowns when clicking outside
  const handleClickOutside = (e) => {
    if (!e.target.closest(".dropdown")) {
      setOpenDropdownId(null);
      setOpenSubmenu({ type: null, id: null });
    }
  };

  const handleOpenOutputModal = (service) => {
    setSelectedService(service);
    setShowOutputModal(true);
    setOpenDropdownId(null);
  };

  // Add event listener when component mounts
  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5 } },
  };

  const slideUp = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.3 } },
  };
  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <motion.h1
                  className="page-title"
                  initial="hidden"
                  animate="visible"
                  variants={fadeIn}
                >
                  Complete Services
                </motion.h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a>RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Complete Services
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <motion.div
          className="section-body mt-4"
          initial="hidden"
          animate="visible"
          variants={slideUp}
        >
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Dep-all">
                <div className="table-responsive">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search by Name"
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search by Phone No"
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                          <div className="input-group">
                            <select className="form-control">
                              <option value="">Filter by State</option>
                              <option value="California">California</option>
                              <option value="New York">New York</option>
                              <option value="Texas">Texas</option>
                              <option value="Florida">Florida</option>
                              <option value="Washington">Washington</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                          <button className="btn btn-primary btn-block">
                            <i className="fa fa-search mr-2"></i> Search
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <motion.div
                    className="card"
                    initial="hidden"
                    animate="visible"
                    variants={slideUp}
                    transition={{ delay: 0.2 }}
                  >
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-hover table-striped table-bordered">
                          <thead className="thead-dark">
                            <tr>
                              <th>Name</th>
                              <th>Phone No</th>
                              <th>Schedule</th>
                              <th>State</th>
                              <th>Employee Name</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {CompleteServices.map((service) => (
                              <tr key={service.id}>
                                <td>{service.name}</td>
                                <td>{service.phoneNo}</td>
                                <td>{service.schedule}</td>
                                <td>{service.state}</td>
                                <td>{service.employeeName}</td>
                                <td>
                                  <span
                                    className={`badge ${
                                      service.status === "Complete"
                                        ? "badge-warning"
                                        : service.status === "In Progress"
                                        ? "badge-info"
                                        : service.status === "Completed"
                                        ? "badge-success"
                                        : "badge-danger"
                                    }`}
                                  >
                                    {service.status}
                                  </span>
                                </td>

                                <td style={{ position: "relative" }}>
                                  <div className="dropdown">
                                    <button
                                      className="btn btn-sm btn-primary dropdown-toggle"
                                      onClick={() => toggleDropdown(service.id)}
                                    >
                                      Actions
                                    </button>

                                    {openDropdownId === service.id && (
                                      <div className="dropdown-menu show">
                                        <div className="dropdown-submenu">
                                          <button
                                            className="dropdown-item"
                                            onClick={(e) =>
                                              toggleSubmenu(
                                                "status",
                                                service.id,
                                                e
                                              )
                                            }
                                          >
                                            Change Status
                                          </button>
                                          {openSubmenu.type === "status" &&
                                            openSubmenu.id === service.id && (
                                              <div className="dropdown-menu show">
                                                {statusOptions.map((option) => (
                                                  <button
                                                    key={option}
                                                    className="dropdown-item"
                                                    onClick={() =>
                                                      handleStatusChange(
                                                        service.id,
                                                        option
                                                      )
                                                    }
                                                  >
                                                    {option}
                                                  </button>
                                                ))}
                                              </div>
                                            )}
                                        </div>

                                        <button
                                          className="dropdown-item"
                                          onClick={() =>
                                            handleOpenDeliveryModal(service)
                                          }
                                        >
                                          Expected Delivery Date
                                        </button>

                                        <div className="dropdown-submenu">
                                          <button
                                            className="dropdown-item"
                                            onClick={() =>
                                              handleOpenOutputModal(service)
                                            }
                                          >
                                            Service Output
                                          </button>
                                          {openSubmenu.type === "output" &&
                                            openSubmenu.id === service.id && (
                                              <div className="dropdown-menu show">
                                                {serviceOutputOptions.map(
                                                  (option) => (
                                                    <button
                                                      key={option}
                                                      className="dropdown-item"
                                                      onClick={() =>
                                                        setSelectedOutput(
                                                          option
                                                        )
                                                      }
                                                    >
                                                      {option}
                                                    </button>
                                                  )
                                                )}
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Delivery Date Modal */}
        {showDeliveryModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Set Delivery Date for {selectedService?.name}</h5>
                <button
                  className="close-btn"
                  onClick={() => setShowDeliveryModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <DatePicker
                  selected={deliveryDate}
                  onChange={(date) => setDeliveryDate(date)}
                  inline
                  minDate={new Date()}
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowDeliveryModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSaveDelivery}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        )}

        {showOutputModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Service Output for {selectedService?.name}</h5>
                <button
                  className="close-btn"
                  onClick={() => setShowOutputModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Select Service Output:</label>
                  <select
                    className="form-control"
                    value={selectedOutput}
                    onChange={(e) => setSelectedOutput(e.target.value)}
                  >
                    <option value="">Select an option</option>
                    {serviceOutputOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowOutputModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    // Save the selected output
                    setShowOutputModal(false);
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
